"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Accordion", {
  enumerable: true,
  get: function get() {
    return _component.Accordion;
  }
});
exports.AccordionSection = void 0;

var _redux = require("@widget-editor/shared/lib/helpers/redux");

var _component = require("./component");

var AccordionSection = (0, _redux.connectState)(function (state) {
  return {
    themeColor: state.theme.color
  };
})(_component.AccordionSection);
exports.AccordionSection = AccordionSection;